const state = {
    data: {},
    edited: {},
    editInfoId: null,
    onEdit: {},
    raw: null,
};

const mutations = {
    android_banners_init_raw(state, payload) {
        state.raw = payload;
    },

    android_banners_init(state, payload) {
        state.data = payload;
    },

    android_banners_edited(state, payload) {
        state.edited = payload;
    },

    android_banners_onedit(state, payload) {
        state.editInfoId = payload.id;
        state.onEdit = payload;
    },

    android_banners_clear(state) {
        state.data = {};
        state.edited = {};
        state.editInfoId = null;
        state.onEdit = {};
        state.raw = null;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/global/stores/android_banners.js